// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pa-1";
export var messageSideRight = "_pa-2";
export var subscribeToBackInStockBubbleContainer = "_pa-0";